import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'link'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = 'primary', size = 'md', className = '', ...props }, ref) => {
    let baseStyles =
      'font-medium rounded-lg transition-all flex items-center justify-center gap-2 select-none w-full cursor-pointer'
    let variantStyles = ''
    let sizeStyles = ''

    // Variants
    if (variant === 'primary') {
      variantStyles =
        'bg-brand-cyan hover:bg-brand-cyan/90 text-white disabled:opacity-50 disabled:cursor-not-allowed'
    } else if (variant === 'outline') {
      variantStyles =
        'border border-brand-border-light text-brand-dark-text hover:bg-brand-bg-light disabled:opacity-50 disabled:cursor-not-allowed'
    } else if (variant === 'ghost') {
      variantStyles =
        'text-brand-copyright hover:text-brand-dark-text opacity-50 hover:opacity-100 disabled:opacity-30 disabled:cursor-not-allowed'
    } else {
      // variant === 'link'
      baseStyles =
        'font-semibold text-brand-cyan hover:text-brand-cyan/85 disabled:opacity-50 disabled:cursor-not-allowed transition-colors inline-flex items-center justify-center cursor-pointer'
    }

    // Sizes
    if (variant !== 'link') {
      if (size === 'sm') {
        sizeStyles = 'h-8 px-3 text-xs'
      } else if (size === 'md') {
        sizeStyles = 'h-10 px-4 text-sm'
      } else {
        // size === 'lg'
        sizeStyles = 'h-11 px-5 text-sm'
      }
    }

    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variantStyles} ${sizeStyles} ${className}`}
        {...props}
      >
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'
